import { IClientProviderProps } from '@hcecbp/provider';

export const getClientConfigs = (): IClientProviderProps['clientConfigs'] => {
  return {
    gatewayApi: { baseURL: (window as any).ENV.BASE_API_GATEWAY_URL },
    adminApi: { baseURL: (window as any).ENV.BASE_URL }
  };
};
